export default __webpack_public_path__ + "static/app-store-button-7191cf0e870a7090d1e47b8065c51b19.svg";